import { Controller, useFormContext } from 'react-hook-form';

import { NeuDatePicker, NeuDatePickerProps } from '@hcahealthcaredpx/neutron-react';

import { REQUIRED_SYMBOL } from './constants';

type FormDatePickerProps = Omit<NeuDatePickerProps, 'name'> & {
  name: string;
};

export const FormDatePicker = ({
  name,
  label,
  required,
  ...rest
}: FormDatePickerProps): JSX.Element => {
  const {
    control,
    trigger,
    formState: { errors },
  } = useFormContext();

  const errorMessage = errors?.[name]?.message as string | undefined;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        return (
          <NeuDatePicker
            value={field.value}
            onNeuChange={(e) => field.onChange(e.value)}
            onNeuBlur={() => trigger(name)}
            invalid={errorMessage || ' Please enter a valid date of birth formatted: MM/DD/YYYY'}
            error={!!errorMessage}
            label={required ? `${label} ${REQUIRED_SYMBOL}` : label}
            required={required}
            {...rest}
          />
        );
      }}
    />
  );
};
